export default __webpack_public_path__ + "static/media/club3.22d6fea4.webp";